import React from 'react';
import { FooterNewsLetterStyled } from './footer.styled';
import { Form } from 'react-bootstrap';
import CustomButton from '../../components/CustomButton';
import {
  FaLinkedin,
  FaInstagram,
  FaTwitter,
  FaFacebook,
  FaWhatsapp,
} from 'react-icons/fa';

const FooterNewsLetter = () => {
  return (
    <FooterNewsLetterStyled>
      <div className="newsletter">
        <div className="social-icons">
          <FaLinkedin />
          <FaInstagram />
          <FaTwitter />
          <FaFacebook />
          <FaWhatsapp />
        </div>
      </div>

      <div className="newsletter-section">
        <h4>Our Newsletter</h4>
        <div className="subscribe-form">
          <Form.Control type="text" />
          <CustomButton type="regular-pricing-btn">Subscribe</CustomButton>
        </div>
      </div>
    </FooterNewsLetterStyled>
  );
};

export default FooterNewsLetter;
